import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import styles from "./styles.module.scss";
import Modal from "../../../../../../components/common/Modal";
import PrimaryButton from "../../../../../../components/common/PrimaryButton";
import OutlinedButton from "../../../../../../components/common/OutlinedButton";
import TextInput from "../../../../../../components/forms/textInput";

interface IReasonPromptModalProps {
  open: boolean;
  title: string;
  handleClose: () => void;
  handleConfirm: (reason: string) => void;
}

/**
 * Collects a required reason before granting or revoking auto-accept-consent (design doc §6.2
 * — every change is a documented, reviewed exception, never a bare toggle).
 */
const ReasonPromptModal = ({
  open,
  title,
  handleClose,
  handleConfirm,
}: IReasonPromptModalProps) => {
  const { t } = useTranslation();
  const [reason, setReason] = useState("");

  useEffect(() => {
    if (!open) {
      setReason("");
    }
  }, [open]);

  return (
    <Modal
      visible={open}
      onCancel={handleClose}
      customModalClassName={styles.modal}
      customModalContainerClassName={styles.modalContainer}>
      <div className={styles.container}>
        <h1 className={styles.title}>{title}</h1>
        <p className={styles.subtitle}>{t("lbl_reason_prompt_subtitle")}</p>

        <TextInput
          value={reason}
          onChange={(e) => setReason(e.target.value)}
          placeholder={t("lbl_reason_prompt_placeholder")}
        />

        <div className={styles.actions}>
          <PrimaryButton
            disabled={!reason.trim()}
            onClick={() => handleConfirm(reason.trim())}>
            {t("lbl_confirm")}
          </PrimaryButton>
          <OutlinedButton onClick={handleClose}>
            {t("lbl_cancel")}
          </OutlinedButton>
        </div>
      </div>
    </Modal>
  );
};

export default ReasonPromptModal;
